import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { clamp } from '../utilities.js';
/**
 * ProgressTracker is an event emitter that helps to track the ongoing progress
 * of many simultaneous actions.
 *
 * ProgressTracker reports progress activity in the form of a progress event.
 * The event.detail.totalProgress value indicates the elapsed progress of all
 * activities being tracked by the ProgressTracker.
 *
 * The value of totalProgress is a number that progresses from 0 to 1. The
 * ProgressTracker allows for the lazy accumulation of tracked actions, so the
 * total progress represents an abstract, non-absolute progress towards the
 * completion of all currently tracked events.
 *
 * When all currently tracked activities are finished, the ProgressTracker
 * emits one final progress event and then resets the list of its currently
 * tracked activities. This means that from an observer's perspective,
 * ongoing activities will accumulate and collectively contribute to the notion
 * of total progress until all currently tracked ongoing activities have
 * completed.
 */
export var ProgressTracker = /*#__PURE__*/function (_EventTarget) {
  _inherits(ProgressTracker, _EventTarget);
  var _super = _createSuper(ProgressTracker);
  function ProgressTracker() {
    var _this;
    _classCallCheck(this, ProgressTracker);
    _this = _super.apply(this, arguments);
    _this.ongoingActivities = new Set();
    _this.totalProgress = 0;
    return _this;
  }
  /**
   * The total number of activities currently being tracked.
   */
  _createClass(ProgressTracker, [{
    key: "ongoingActivityCount",
    get: function get() {
      return this.ongoingActivities.size;
    }
    /**
     * Registers a new activity to be tracked by the progress tracker. The method
     * returns a special callback that should be invoked whenever new progress is
     * ready to be reported. The progress should be reported as a value between 0
     * and 1, where 0 would represent the beginning of the action and 1 would
     * represent its completion.
     *
     * There is no built-in notion of a time-out for ongoing activities, so once
     * an ongoing activity is begun, it is up to the consumer of this API to
     * update the progress until that activity is no longer ongoing.
     *
     * Progress is only allowed to move forward for any given activity. If a lower
     * progress is reported than the previously reported progress, it will be
     * ignored.
     */
  }, {
    key: "beginActivity",
    value: function beginActivity(reason) {
      var _this2 = this;
      var activity = {
        progress: 0,
        completed: false
      };
      this.ongoingActivities.add(activity);
      if (this.ongoingActivityCount === 1) {
        // Announce the first progress event (which should always be 0 / 1
        // total progress):
        this.announceTotalProgress(activity, 0, reason);
      }
      return function (progress) {
        var nextProgress;
        nextProgress = Math.max(clamp(progress, 0, 1), activity.progress);
        if (nextProgress !== activity.progress) {
          _this2.announceTotalProgress(activity, nextProgress, reason);
        }
        return activity.progress;
      };
    }
  }, {
    key: "announceTotalProgress",
    value: function announceTotalProgress(updatedActivity, nextProgress, reason) {
      var progressLeft = 0;
      var completedActivities = 0;
      if (nextProgress == 1.0) updatedActivity.completed = true;
      var _iterator = _createForOfIteratorHelper(this.ongoingActivities),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var activity = _step.value;
          var progress = activity.progress;
          progressLeft += 1.0 - progress;
          if (activity.completed) {
            completedActivities++;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var lastProgress = updatedActivity.progress;
      updatedActivity.progress = nextProgress;
      // Advance the total progress by the fraction of total remaining progress
      // due to this activity.
      this.totalProgress += (nextProgress - lastProgress) * (1.0 - this.totalProgress) / progressLeft;
      var totalProgress = completedActivities === this.ongoingActivityCount ? 1.0 : this.totalProgress;
      this.dispatchEvent(new CustomEvent('progress', {
        detail: {
          totalProgress: totalProgress,
          reason: reason
        }
      }));
      if (completedActivities === this.ongoingActivityCount) {
        this.totalProgress = 0.0;
        this.ongoingActivities.clear();
      }
    }
  }]);
  return ProgressTracker;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));